// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

// Styles
import '../../styles/investments.css';

export default class Link extends React.Component {
    render = () => {
        return (<a href={this.props.href} target="_blank" rel="noopener noreferrer" className="investments-link">
            <img
                src="https://static.stax.ai/images/icons/action-open.png"
                alt="Open"
            />
        </a>);
    }
}